import { get as historyGet } from "../../state/history";

class HistoryFilledField extends HTMLElement {
	connectedCallback() {
		const input = this.querySelector("input");
		if (!input || input.value !== "" || !this.hasAttribute("type")) {
			return;
		}
		historyGet().some(({ type, label }) => {
			if (type !== this.getAttribute("type")) {
				return false;
			}

			input.value = label;
			return true;
		});
	}
}
customElements.define("esc-history-filled-field", HistoryFilledField);
